"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var config_1 = require("../config");
var fixedFooter = function (props) {
    var hide = props.hide, rest = __rest(props, ["hide"]);
    var b = config_1.block("fixed_footer");
    var className = b({}).mix(props.className).toString();
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !hide, timeout: 300, classNames: b() }, function (state) { return (react_1.default.createElement("div", __assign({ className: className }, rest),
        react_1.default.createElement("div", { className: b("container") }, props.children))); }));
};
exports.default = fixedFooter;
//# sourceMappingURL=index.js.map